const global = window

inputs.types.color = function (data, name, niceName, type, input, parent, inputWindow) {
    const inputColorChange = function (color) {
        if (color) {
            const currentColor = color.toLocaleString()
            input.val(currentColor)
            input.css('background-color', currentColor)
            input.css('border-color', currentColor)
            if (color.isDark()) {
                input
                    .css('color', '#ffffff')
                    .next()
                    .css('color', '#ffffff')
            } else {
                input
                    .css('color', '#000000')
                    .next()
                    .css('color', '#000000')
            }
        } else {
            input.val('')
            input.css('background-color', '')
            input.css('border-color', '')
            input.css('color', '').next().css('color', '')
        }
    }
    /*
    input.spectrum({
        preferredFormat: 'hex',
        color: input.val(),
        showPalette: true,
        maxSelectionSize: 6,
        hideAfterPaletteSelect: true,
        showAlpha: true,
        showButtons: false,
        showInput: false,
        allowEmpty: true,
        offset: function() {
            const offset = input.offset();
            const height = input.outerHeight();
            return {top: offset.top+height, left: offset.left}
        },
        move(color) {
            inputColorChange(color)
        },
    })
    input.change(function () {
        $(this).spectrum('set', $(this).val())
        inputColorChange($(this).spectrum('get'))
    })
    input.click(function () {
        $(this).spectrum('show')
    })
    inputColorChange(input.spectrum('get'))
    */
    return data
}
